import * as R from 'ramda';
import parseSaleCommentBefore from './parseSaleCommentBefore';

export default function parseSaleCommentsBefore(items) {
  return R.map(parseSaleCommentBefore, items);
}
